// extracted by mini-css-extract-plugin
export var typingIndicator = "_rr-0";